export const normalizeBackendChapterId = (value: unknown): number | undefined => {
  if (typeof value === 'number') {
    return Number.isSafeInteger(value) && value > 0 ? value : undefined;
  }

  const matched = String(value ?? '').trim().match(/^(?:chapter-)*(\d+)$/);
  if (!matched) return undefined;
  const parsed = Number(matched[1]);
  return Number.isSafeInteger(parsed) && parsed > 0 ? parsed : undefined;
};
